(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

jQuery(function ($) {
  $(document).ready(function () {
    insightsHero();
    insightsIntro();

    $('.t-single-insight-sidenav-list a:not(.is-active)').on('click', function () {
      $('.t-single-insight-sidenav-list a.is-active').removeClass('is-active');
      $(this).addClass('is-active');
    });

    $(window).on("scroll", onScroll);

    function onScroll(event) {
      if ($(window).innerWidth() >= 768) {
        if ($('.t-single-insight-sidenav-list').length > 0) {
          var scrollTop = $(window).scrollTop();
          var sideNavTop = $('.t-single-insight-sidenav').offset().top;
          var windowBottom = scrollTop + $(window).height();
          windowBottom = windowBottom - $(window).height() / 2 - 100;

          if (scrollTop > sideNavTop - 120) {
            $('.t-single-insight-sidenav').addClass('sticky');
          } else {
            $('.t-single-insight-sidenav').removeClass('sticky');
          }

          $('.t-single-insight-sidenav-list a.is-anchor').each(function () {
            var currLink = $(this);
            var refElement = $(currLink.attr("href"));
            var refElementOffset = refElement.offset().top;
            if (refElementOffset < windowBottom) {
              $('.t-single-insight-sidenav-list a').removeClass("is-active");
              currLink.addClass("is-active");
            } else {
              currLink.removeClass("is-active");
            }
          });
        }
      }
    }
  });
  $(window).on('load', function () {
    insightsHero();
  });
  $(window).on('orientationchange resize', function () {
    insightsIntro();
  });

  function insightsHero() {
    var proseH = $('.t-single-insight-hero .m-standard-header-prose').innerHeight();
    var windowH = $(window).innerHeight();
    windowH = windowH * 0.9;
    if ($(window).innerWidth() >= 768) {
      windowH = windowH * 0.7;
    }
    if (proseH > windowH) {
      var newH = proseH + 90;
      if ($(window).innerWidth() >= 768) {
        $('.t-single-insight .m-standard-header').height(newH);
      } else if ($(window).innerWidth() >= 992) {
        newH = proseH + 90;
        $('.t-single-insight .m-standard-header').height(newH);
      } else {
        newH = proseH + 80;
        $('.t-single-insight .m-standard-header').height(newH);
      }
    }
  }

  function insightsIntro() {
    var modH = $('.t-single-insight-intro .container').height();
    var newH = modH - 130;
    if ($(window).innerWidth() >= 768) {
      $('.t-single-insight-intro-inner').css('height', newH);
      if ($('.t-single-insight-intro').hasClass('t-single-insight-stats') || $('.t-single-insight-intro').hasClass('t-single-insight-highlights')) {
        newH = modH - 100;
        $('.t-single-insight-intro-inner').css('height', newH);
      }
    } else {
      $('.t-single-insight-intro-inner').css('height', 'auto');
    }
  }
});

},{}]},{},[1]);
